export function isNotNull<T>(val: T | null | undefined): asserts val is T {
	if (val === null || val === undefined) {
		throw new Error('must have value or be defined!');
	}
}
